<template>
    <el-dialog :visible="visible" @close="handleClose" class="narrow-dialog" center :close-on-click-modal="false">
        <div class="dialog-title">{{ mode == "add" ? "新增" : "編輯" }}</div>
        <el-input v-model="name" placeholder="請輸入"></el-input>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleDelete" v-if="mode == 'edit' && !isQR()" round>刪 除</el-button>
            <el-button type="primary" round @click="handleClose(true)">確定</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        inputObject: {
            type: Object,
            default: null,
        },
    },
    created() {
        if (this.inputObject) {
            this.name = this.inputObject.name;
            this.setMode('edit');
        } else {
            this.setMode('add');
        }
    },
    data() {
        return {
            name: '',
            mode: 'add',
        };
    },
    methods: {
        handleClose(isSubmit) {
            if (isSubmit && this.name.trim() == '') {
                return;
            }
            this.$emit('close', this.name);
        },
        handleDelete() {
            this.$emit('delete', this.name);
        },
        setMode(mode) {
            this.mode = mode;
        },
    },
};
</script>
